<template>
    <div>
      <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
    
                <el-table-column prop="deviceName" label="项目名称" width="400">
                </el-table-column>
                <el-table-column prop="position" label="设备位置" width="200">
                </el-table-column>
                <el-table-column prop="tips" label="备注" width="200">
                </el-table-column>
                <el-table-column prop="isRegister" label="授权信息" width="350">
                    <template slot-scope="scope">
                        <span :class="scope.row.isRegister === '已注册'? 'online-dot' : 'offline-dot'"></span><span
                            style="margin-left: 5px;">{{scope.row.registerInfo}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lanIp" label="内网IP" width="200">
                </el-table-column>
                <el-table-column prop="deviceId" label="设备ID" width="350">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="300">
                    <template slot-scope="scope">
                        <!-- 新增批量注册按钮 -->
                        <el-button type="success"  size="small"  @click="openRemarkPopup(scope.row)">修改备注</el-button>
                        <el-button  v-if="scope.row.children && scope.row.children.length > 0" type="warning" @click="batchRegister(scope.row)" size="small">批量注册</el-button>
                        <el-button type="primary" @click="add(scope.row)" size="small">设备授权</el-button>
                    </template>
                </el-table-column>
      </el-table>
      <!-- 新增复选框选择的模态框 -->
      <el-dialog title="批量注册" :visible.sync="batchDialogVisible" width="50%">
       
        <el-form ref="ruleAllForm" :model="ruleAllForm":rules="rules" label-width="80px">
            <el-form-item label="授权类型" prop="type">
                <el-select v-model="ruleAllForm.type" placeholder="请选择授权类型">
                    <el-option label="永久" value="forever"></el-option>
                    <el-option label="天数" value="day"></el-option>
                    <el-option label="次数" value="frequency"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  v-if="ruleAllForm.type=='day'" label="授权天数"  >
                <el-date-picker prop="day"
                    v-model="value1"
                    type="datetime"
                    placeholder="选择结束日期时间">
                    prop="day"
                </el-date-picker>
            </el-form-item>
            <el-form-item  v-if="ruleAllForm.type=='frequency'" label="授权次数" >
                <el-input v-model="ruleAllForm.time" placeholder="请输入授权次数" ></el-input>
            </el-form-item>
            <el-form-item >
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            </el-form-item>  
            <el-form-item >
                <el-checkbox-group v-model="ruleAllForm.selectedIds">
                    <el-checkbox v-for="item in selectedChildren" :label="item.deviceId" :key="item.id">项目名称：{{item.deviceName}}   设备ID：{{item.deviceId}}   内网IP：{{item.lanIp}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>  
            <el-form-item >
                <el-button @click="batchDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitForm('ruleAllForm')">确 定</el-button>
            </el-form-item> 
        </el-form>
        
    </el-dialog>

     <!-- 返回注册码弹出框 -->
     <el-dialog title="注册码" :visible.sync="dialogV" width="70%">
      <el-table :data="codeList" style="width: 100%">
        <el-table-column prop="deviceId" label="设备ID" width="300"></el-table-column>
        <el-table-column prop="registerCode" label="注册码"  width="800"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogV = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 修改备注弹出框 -->
	<el-dialog  :visible.sync="dialogRemarkPopup" width="30%">
		<div style="width:300px; height:300px;  padding:10px;"> 
												
			<h3 style="text-align: center;margin-bottom: 20px;">备注修改</h3> 
		   <div  style="color:#6a6a6a;">设备ID: {{UpdateRemarkRequest.deviceID}}</div> 
		   <el-input v-model="UpdateRemarkRequest.remark" placeholder="请输入设备备注" style="margin-top: 10px;"></el-input>
		   
		  
		<el-button type="danger" @click="submitRemark" style="margin-top: 10px;">点击提交</el-button> 
		<el-button type="success" @click="closeRemarkPopup" style="margin-top: 10px;">点击取消</el-button> 
	  </div>
   </el-dialog>
    </div>
  </template>
  <style>
  .el-table td:focus {
    outline: none;
}

</style>
  <script>
  export default {
    data() {
      return {

        UpdateRemarkRequest:{
									 deviceID:'',
									 remark:'',
			},
      dialogRemarkPopup:false,
        params:[],
          pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
        value1: '',



          fullscreenLoading: false,
            dialogVisible: false,
            dialogV: false,
            infodialog: false,
            tableData: [],
            batchDialogVisible: false,
            checkAll: false,
            isIndeterminate: false,
            selectedChildren: [],
            codeList: {

            },
            ruleAllForm: {
            type: '',
            time:'',
            startTime:'',
            endTime:'',
            selectedIds: [],
            creatTime:''
          
          },
          rules: {
            
            type: [
              { required: true, message: '请选择授权类型', trigger: 'change' }
            ],
            day:[
            { required: true, message: '请输入授权天数', trigger: 'blur' }
            ],
           
            
           
          }
      }
    },
    created() {
        this.request.get("/getLanDevices").then(res => {
            console.log(res);
            this.tableData = res.info;
        }).catch(error => {
            console.log(error);
        })
    },
    methods: {
      openRemarkPopup(item) {
			this.UpdateRemarkRequest.deviceID=item.deviceId;
			this.dialogRemarkPopup = true;
		},
		closeRemarkPopup(){
			this.dialogRemarkPopup = false;
			this.UpdateRemarkRequest.deviceID='';
			this.UpdateRemarkRequest.remark='';
		},
		
		submitRemark(){
			
			if(this.UpdateRemarkRequest.deviceId===''){
				this.$message.error('设备ID不能为空');
				
				return;
			}
			if(this.UpdateRemarkRequest.remark===''){
				this.$message.error('备注不能为空');
				
				return;
			}
			// 假设 request 是封装好的请求工具
			this.request.post("/updateRemark", this.UpdateRemarkRequest).then(res => {
			    if (res.code === '0') {
			        console.log('设备备注修改成功');
			        this.closeRemarkPopup(); // 假设关闭弹窗的方法名是 closePopup
					    this.$message({ message: res.data, type: 'success' });
              this.request.get("/getLanDevices").then(res => {
                console.log(res);
                this.tableData = res.info;
              }).catch(error => {
                console.log(error);
              })
			        
			    } else {
			        console.log('设备备注修改失败');
			        this.closeRemarkPopup();
					this.$message.error(res.msg);
			    }
			}).catch(errors => {
			    console.log(errors);
			    this.closeRemarkPopup();
				this.$message.error('请求出错，请稍后重试');
			    
			});
		},



        add(row) {
            const deviceid = row.deviceId;
            const _name = row.deviceName;
            this.$router.push({path: '/home/RegisterDevice', query: {id: deviceid, Name: _name}})
        },
        lockDevice(row) {
            const deviceid = row.deviceId;
            console.log('要锁定的设备ID：', deviceid);
            this.request.get("/LockDevice", {params: {"ID": deviceid}}).then(res => {
                if (res.code === '0') {
                    this.$message({message: res.data, type: 'success'});
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(error => {
                console.log(error);
            })
        },
        unLockDevice(row) {
            const deviceid = row.deviceId;
            console.log('要解锁的设备ID：', deviceid);
            this.request.get("/UnLockDevice", {params: {"ID": deviceid}}).then(res => {
                if (res.code === '0') {
                    this.$message({message: res.data, type: 'success'});
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(error => {
                console.log(error);
            })
        },
        batchRegister(parentRow) {
            this.selectedChildren = parentRow.children;
            this.batchDialogVisible = true;
        },
        doBatchRegister() {
            const loading = this.$loading({
          lock: true,
          text: '正在注册',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
            const ids = this.ruleForm.selectedIds;
            // 这里可以添加向后端发送批量注册请求的逻辑，目前只打印选择的ID
            console.log('准备批量注册的设备ID:', ids);
            this.batchDialogVisible = false;
            this.selectedIds = [];
        },
        submitForm(formName) {
         
         this.$refs[formName].validate((valid) => {
           if (valid) {
             if(this.ruleAllForm.time=="" && this.ruleAllForm.type=="frequency"){
               this.$message.error("请输入授权次数");
             }else if( this.ruleAllForm.selectedIds.length<=0){
                this.$message.error("请勾选注册设备");
             }else{

               const timestamp = new Date().getTime();
               const date = new Date(timestamp);
               this.ruleAllForm.creatTime= date.toLocaleString();
               if(this.ruleAllForm.type=="day"){
                 const timestamp1 =this.value1.getTime();
                 const date1 = new Date(timestamp1);
                 this.ruleAllForm.endTime=date1.toLocaleString()
               }
               console.log('准备批量注册的设备ID:', this.ruleAllForm.selectedIds);

               const loading = this.$loading({
          lock: true,
          text: '正在注册',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
       
               this.request.post("/DeviceAllRegister", this.ruleAllForm).then(res => {
                if(res.code=='0'){
                      this.$message({message: '设备授权成功',type: 'success'});
                      console.log(res);
                      loading.close();
                      this.ruleAllForm.selectedIds=[];
                      this.codeList =JSON.parse(res.registerCode);
                      this.batchDialogVisible = false;
                      this.dialogV=true;
                     
                 }else{
                      this.$message.error(res.msg);
                      this.batchDialogVisible = false;
                      this.ruleAllForm.selectedIds=[];
                }
            })
           
             }
              
           } else {
             console.log('error submit!!');
             return false;
           }
         });
       },
       handleCheckAllChange(val) {
            if (val) {
                this.ruleAllForm.selectedIds = this.selectedChildren.map(item => item.deviceId);
            } else {
                this.ruleAllForm.selectedIds = [];
            }
            this.isIndeterminate = false;
        }
      
    }
  }
  </script>